module.exports = __webpack_public_path__ + "static/media/fishseller2.1e5c9961.wav";